/**
 * The pages that the user will go through on successful completion.
 * Note: The order of the pages is important as it is used to calculate the progress percentage.
 */
export enum Pages {
  OPTIN = 'optin',
  REGISTRATION = 'registration',
  VERIFICATION = 'verification',
  PLAID = 'plaid',
}

/**
 * The pages that the user will be redirected to if there is an error in the flow.
 */
export enum FallbackPages {
  REGISTRATION_RETRY = 'registration_retry',
  VERIFICATION_RETRY = 'verification_retry',
  PLAID_RETRY = 'plaid_retry',
}

export type FKCPages = Pages | FallbackPages;

export interface TermsAndPrivacyResponse {
  id: number;
  url: string;
  revision: number;
}

export interface SignUpResponse {
  publisher_user_id: string;
}

export interface LinkTokenResponse {
  link_token: string;
}

export interface DataToSign {
  payload?: string;
  params?: Record<string, string>;
}

export interface SaveAccessTokenPayload {
  public_token: string;
  institution_id: string;
  institution_name: string;
}
